module.exports = __webpack_public_path__ + "img/facebook.9f80d4ce.svg";